// A API de /reports (GET) não interpreta o formato lineId[]=a&lineId[]=b
// gerado pelo axios para arrays; espera valores separados por vírgula
// (lineId=a,b), como já é feito com o emvType.
export const joinArrayParams = (params: { [key: string]: any }) =>
  Object.fromEntries(
    Object.entries(params).map(([key, value]) => [
      key,
      Array.isArray(value) ? value.join(',') : value,
    ]),
  );

export default joinArrayParams;
